export default __webpack_public_path__ + "4920d9c2ee5edf421c94f3bf561145d3.png";